import APIHelpCenterCategories from "@/api/modules/help-center-categories";

const state = () => ({
  categoriesList: [],
  loader: false,
  headersData: {},
  category: {}
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    }
  },
  actions: {
    getCategoriesList({ commit }, params) {
      return APIHelpCenterCategories.getAllCategories(params).then(response => {
        commit("SET_DATA", { type: "headersData", data: response.headers });
        commit("SET_DATA", {
          type: "categoriesList",
          data: response.data.categories
        });
      });
    },

    deleteCategory({ dispatch }, id) {
      return APIHelpCenterCategories.deleteCategory(id).then(() =>
        dispatch("getCategoriesList")
      );
    },

    createCategory(_, payload) {
      return APIHelpCenterCategories.createCategory(payload);
    },

    updateCategory(_, { id, data }) {
      return APIHelpCenterCategories.updateCategory(id, data);
    },

    getCategory({ commit }, id) {
      return APIHelpCenterCategories.getCategory(id).then(response => {
        if (response && response.data) {
          commit("SET_DATA", {
            type: "category",
            data: response.data.category
          });
          commit("SET_DATA", {
            type: "category",
            data: response.data.category
          });
        }
      });
    }
  }
};
